var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftHand13049({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.517 88.253 c -1.29 0 -2.579 -0.142 -3.835 -0.423 L 25.67 84.706 c -1.526 -0.34 -3.095 -0.513 -4.662 -0.513 H 15.35 c -0.552 0 -1 -0.447 -1 -1 V 66.051 c 0 -0.273 0.112 -0.534 0.309 -0.723 c 0.197 -0.189 0.467 -0.289 0.736 -0.276 l 2.223 0.101 c 0.004 0 0.009 0 0.014 0 c 0.573 0 1.169 -0.228 1.644 -0.642 c 5.248 -4.584 10.101 -7.802 18.067 -9.682 c 2.589 -0.578 5.052 -0.448 7.659 -0.311 c 3.741 0.196 7.613 0.403 11.978 -1.663 c 0.881 -0.418 3.564 -1.69 5.758 0.085 c 1.167 0.946 1.903 2.508 1.876 3.979 c -0.022 1.172 -0.517 2.179 -1.392 2.834 c -4.415 3.311 -8.276 3.92 -11.682 4.457 c -1.657 0.261 -3.245 0.511 -4.793 1.053 c 7.695 5.101 23.966 2.203 36.029 0.057 c 2.548 -0.452 5.049 1.075 5.808 3.556 c 0.77 2.514 -0.472 5.192 -2.886 6.229 L 58.214 86.711 c -2.12 0.912 -4.373 1.394 -6.69 1.428 l 0 0 l -7.755 0.112 C 43.685 88.252 43.601 88.253 43.517 88.253 z M 16.35 82.193 h 4.657 c 1.714 0 3.429 0.188 5.098 0.562 l 14.012 3.124 c 1.186 0.265 2.4 0.392 3.623 0.372 l 7.754 -0.112 c 2.054 -0.03 4.05 -0.457 5.935 -1.268 l 27.486 -11.607 c 1.469 -0.632 2.227 -2.268 1.757 -3.803 c -0.464 -1.515 -1.983 -2.445 -3.546 -2.173 c -13.189 2.348 -31.256 5.565 -39.01 -1.547 c -0.243 -0.223 -0.36 -0.55 -0.314 -0.876 c 0.045 -0.325 0.248 -0.608 0.543 -0.756 c 2.302 -1.153 4.528 -1.504 6.885 -1.875 c 3.331 -0.525 6.777 -1.068 10.794 -4.081 c 0.382 -0.286 0.58 -0.714 0.591 -1.273 c 0.017 -0.863 -0.439 -1.822 -1.136 -2.386 c -0.52 -0.423 -1.463 -0.863 -3.643 0.168 c -4.821 2.283 -9.134 2.057 -12.939 1.853 c -2.465 -0.129 -4.795 -0.254 -7.105 0.263 c -7.587 1.79 -12.052 4.743 -17.199 9.239 c -0.847 0.74 -1.926 1.135 -3.027 1.135 l -1.215 -0.055 V 82.193 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.35 90 H 2.188 c -0.552 0 -1 -0.447 -1 -1 V 62.778 c 0 -0.553 0.448 -1 1 -1 H 15.35 c 0.552 0 1 0.447 1 1 V 89 C 16.35 89.553 15.902 90 15.35 90 z M 3.188 88 H 14.35 V 63.778 H 3.188 V 88 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 58.976 69.948 l -1 -1.733 l 21.042 -12.149 c 2.487 -1.436 4.032 -4.112 4.032 -6.984 V 23.068 c 0 -2.872 -1.545 -5.548 -4.032 -6.984 L 56.487 3.076 c -2.487 -1.437 -5.575 -1.436 -8.064 0 l -22.53 13.007 c -2.487 1.436 -4.032 4.112 -4.032 6.984 v 26.015 c 0 2.871 1.545 5.548 4.032 6.984 l 3.472 2.005 l -1 1.733 l -3.472 -2.005 c -3.104 -1.792 -5.032 -5.132 -5.032 -8.716 V 23.068 c 0 -3.584 1.928 -6.924 5.032 -8.716 l 22.53 -13.007 c 3.104 -1.791 6.96 -1.793 10.064 0 l 22.53 13.007 c 3.104 1.792 5.032 5.132 5.032 8.716 v 26.015 c 0 3.584 -1.929 6.924 -5.032 8.716 L 58.976 69.948 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.577 47.098 c -0.339 0 -0.664 -0.174 -0.85 -0.473 L 30.134 29.56 v 16.538 c 0 0.553 -0.448 1 -1 1 s -1 -0.447 -1 -1 V 26.053 c 0 -0.447 0.296 -0.839 0.726 -0.962 c 0.43 -0.123 0.889 0.055 1.124 0.435 l 10.593 17.066 V 26.053 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 20.046 c 0 0.446 -0.296 0.839 -0.726 0.962 C 41.76 47.086 41.668 47.098 41.577 47.098 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.349 47.098 c -0.553 0 -1 -0.447 -1 -1 V 26.053 c 0 -0.552 0.447 -1 1 -1 h 8.887 c 0.553 0 1 0.448 1 1 s -0.447 1 -1 1 h -7.887 v 19.046 C 50.349 46.651 49.902 47.098 49.349 47.098 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.415 37.076 h -7.066 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 7.066 c 0.553 0 1 0.448 1 1 S 56.968 37.076 56.415 37.076 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.776 27.053 H 64.384 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 11.392 c 0.553 0 1 0.448 1 1 S 76.329 27.053 75.776 27.053 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.081 47.098 c -0.553 0 -1 -0.447 -1 -1 V 26.053 c 0 -0.552 0.447 -1 1 -1 c 0.553 0 1 0.448 1 1 v 20.046 C 71.081 46.651 70.634 47.098 70.081 47.098 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftHand13049);
export default __webpack_public_path__ + "static/media/nft-hand-13049.5245d495cdfc3d8554f54e85a097b47f.svg";
export { ForwardRef as ReactComponent };